import React, { useState } from "react";
import { FaPlus, FaEllipsisV, FaEdit, FaTrash, FaUser, FaPrint, FaRemoveFormat } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { MdDelete } from "react-icons/md";

const AcademicSession = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [sessions, setSessions] = useState([
    { id: 1, label: "FY-2023-2024", fromDate: "2023-06-01", toDate: "2024-05-31" },
    { id: 2, label: "FY-2022-2023", fromDate: "2022-06-01", toDate: "2023-05-31" },
  ]);
  const [currentSession, setCurrentSession] = useState(null);

  const openModal = (session = null) => {
    setCurrentSession(session);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentSession(null);
  };

  const openDeleteModal = (session) => {
    setCurrentSession(session);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setCurrentSession(null);
  };

  const deleteSession = () => {
    setSessions(sessions.filter((s) => s.id !== currentSession.id));
    closeDeleteModal();
  };

  return (
    <div className="p-6 min-h-screen bg-gray-100">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-semibold">Academic Sessions</h1>
        <button
          onClick={() => openModal()}
          className="bg-pragyaBlue text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-pragyaBlue/90 transition"
        >
          <FaPlus />
          <h2 className='flex items-center text-md font-semibold leading-tight text-gray-800 text-white'>
            Create Academic Session
          </h2>


        </button>
      </div>

      {/* Table Section */}
      <div className="bg-white p-6 rounded-xl shadow-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse min-w-[600px]">
            <thead>
              <tr className="bg-gray-100 text-gray-700 border-b">
                <th className="p-4 text-left font-semibold">Label</th>
                <th className="p-4 text-left font-semibold">From Date</th>
                <th className="p-4 text-left font-semibold">To Date</th>
                <th className="p-4 text-right font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map((session) => (
                <tr
                  key={session.id}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="p-4">{session.label}</td>
                  <td className="p-4">{session.fromDate}</td>
                  <td className="p-4">{session.toDate}</td>


                  <td className="px-2 py-2 text-right relative">
                    <div className="flex justify-end space-x-2">

                      <FaTrash onClick={() => openDeleteModal(session)}
                        className="w-6 h-6 bg-pragyaOrange p-1 rounded-md text-white cursor-pointer hover:scale-105 transition duration-200" title="Delete Session" />

                      <FaEdit
                        onClick={() => openModal(session)}
                        className="w-6 h-6 bg-pragyaBlue p-1 rounded-md text-white cursor-pointer hover:scale-105 transition duration-200" title="Edit Session" />

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-fitinline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
            <h2 className="text-2xl font-semibold mb-4">
              {currentSession ? "Edit Session" : "Add New Session"}
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700">Session Name</label>
                <input type="text" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-gray-700">From Date</label>
                <input type="date" className="w-full p-2 border rounded" />
              </div>
              <div>
                <label className="block text-gray-700">To Date</label>
                <input type="date" className="w-full p-2 border rounded" />
              </div>
            </div>
            <div className="flex justify-end mt-6 space-x-4">
              <button onClick={closeModal} className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500">Cancel</button>
              <button className="px-4 py-2 bg-pragyaBlue text-white rounded hover:bg-pragyaBlue/90">{currentSession ? "Update" : "Add"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 text-center">
            <h2 className="text-xl font-semibold mb-4">Are you sure?</h2>
            <p className="mb-6">Do you want to delete this session?</p>
            <div className="flex justify-center space-x-4">
              <button onClick={closeDeleteModal} className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500">No</button>
              <button onClick={deleteSession} className="px-4 py-2 bg-pragyaOrange text-white rounded hover:bg-pragyaOrange/90">Yes</button>
            </div>
          </div>
        </div>


      )}
    </div>
  );
};

export default AcademicSession;
